import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-validar-documento',
  templateUrl: './validar-documento.component.html',
  styleUrls: ['./validar-documento.component.css']
})
export class ValidarDocumentoComponent implements OnInit {

  cargando   = true;
  valido     = false;
  docId      = '';
  datos: any = null;

  constructor(
    private _route: ActivatedRoute,
    private _http: HttpClient,
    private _router: Router,
    private _location: Location
  ) {}

  ngOnInit(): void {
    this.docId = this._route.snapshot.paramMap.get('docId') || '';

    if (!this.docId) {
      this._router.navigateByUrl('/inicio');
      return;
    }

    this._location.replaceState('/validar');

    this._http.get<any>(`${environment.apiUrl}public/validar/${this.docId}`)
      .subscribe({
        next: (res) => {
          this.cargando = false;
          if (res?.data?.valido) {
            this.valido = true;
            this.datos  = res.data;
          }
        },
        error: () => { this.cargando = false; }
      });
  }

  tipoDocLabel(): string {
    if (!this.datos?.tipoDoc) return '';
    return this.datos.tipoDoc === 'HISTORIAL' ? 'Historial Completo' : 'Certificación Académica';
  }
}
